import React from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Components
import GeneralInformation from "../containers/Editor/GeneralInformation";
import EpisodeForm from "../containers/Editor/EpisodeForm";
import EpisodeList from "../containers/Editor/EpisodeList";
import EpisodePreviewModal from "../containers/Editor/EpisodePreviewModal";
import StatusBar from "../containers/Editor/StatusBar";
import Navbar from "../components/Layout/Navbar";

//
import useEpisodeForm, { tabs } from "../utils/hooks/useEpisodeForm";

const Editor = () => {
  const { t } = useTranslation();
  const {
    currentTab,
    setCurrentTab,
    activeEpisode,
    setActiveEpisode,
    validateClicked,
    setValidateClicked,
    modalOpen,
    setModalOpen,
    checkboxList,
    form,
    errors,
    isValid,
    handleSubmit,
    setValue,
    setFocus,
    episodes,
    prepend,
    remove,
    latestEpisodes,
    latestTitle,
    latestImageUrl,
    latestUrl,
    showHighlight,
    setShowHighlight,
  } = useEpisodeForm();

  return (
    <form
      onSubmit={handleSubmit(() => {
        setShowHighlight(true);
      })}
    >
      <Navbar
        setValidateClicked={setValidateClicked}
        showHighlight={showHighlight}
        setShowHighlight={setShowHighlight}
      />
      <EpisodePreviewModal
        activeEpisode={latestEpisodes?.[activeEpisode]}
        podcastDetails={{
          title: latestTitle,
          image_url: latestImageUrl,
          url: latestUrl,
        }}
        open={modalOpen}
        setModalOpen={setModalOpen}
      />
      <div>
        <StatusBar
          errors={errors}
          validateClicked={validateClicked}
          checkboxList={checkboxList}
          setValidateClicked={setValidateClicked}
        />
        <div className="content col-bg-light-grey-alt px-0 px-md-3">
          <ul className="nav-tabs nav nav-pills nav-fill d-flex d-md-none">
            {tabs.map((tab) => {
              const isActive = tab.id === currentTab;
              return (
                <li
                  className="nav-item"
                  key={tab.id}
                  onClick={() => setCurrentTab(tab.id)}
                >
                  <a
                    className={`nav-link ${isActive ? "active" : ""}`}
                    aria-current="page"
                    href="#"
                  >
                    {t(tab.text)}
                  </a>
                </li>
              );
            })}
          </ul>
          <div className="container-fluid">
            <FormProvider {...form}>
              <div className="row">
                <GeneralInformation
                  isActive={currentTab === "podcast-info"} // this field is for mobile as we are using tabs on mobile
                  errors={errors}
                  checkboxList={checkboxList}
                  latestImageUrl={latestImageUrl}
                  isValid={isValid}
                  setValidateClicked={setValidateClicked}
                  validateClicked={validateClicked}
                />
                <EpisodeForm
                  isActive={currentTab === "new-episode"} // this field is for mobile as we are using tabs on mobile
                  episodeToRender={episodes[activeEpisode]}
                  errors={errors}
                  activeEpisode={activeEpisode}
                  setValue={setValue}
                  setModalOpen={setModalOpen}
                />
                <EpisodeList
                  isActive={currentTab === "episodes"} // this field is for mobile as we are using tabs on mobile
                  episodes={episodes}
                  prepend={prepend}
                  remove={remove}
                  setActiveEpisode={setActiveEpisode}
                  activeEpisode={activeEpisode}
                  errors={errors}
                  setFocus={setFocus}
                  setCurrentTab={setCurrentTab}
                />
              </div>
            </FormProvider>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Editor;
